module.exports = __webpack_public_path__ + "static/media/ID_Card_Verify_Selected.a8e9369d.svg";